
import axios from "./themeInstance"
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'
export default async (theme: any) => {
  const payload ={
    "value":{
      "id" : theme.id
    }
  };

  try {
    const response: any = await axios.put(`/settings/theme`, payload);
    notifyOnboardingStatusChanged()
    return response.data
  } catch (error) {
    return null
  }
}
